export default __webpack_public_path__ + "static/media/checking-mark.2109dd26.svg";